import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Tabs, Card, Table, Alert, Tag, Modal } from 'antd'
import { req_single_cms_school_student, req_single_cms_learnmap_yearplan, req_single_cms_learnmap_talent_tab, req_single_cms_learnmap_talent_suggest_course } from '../../api'
import { getNowAcademicYear, getNowAcademicSemester } from '../../utils/dateUtil'

import CoursemapStudentLearnedCourseModal from './coursemap-student-learned-course-modal'
import CoursemapStudentSuggestCourseModal from './coursemap-student-suggest-course-modal'
const { TabPane } = Tabs
class CoursemapStudentCourseSuggest extends Component {
    // 基礎通用參數 //////////////////////////////////////////////  
    state = {
        item: {},
        items: [],
        deviceWidth: 0,
        tableloading: false,
        loading: false,
        nowAcademicYear: getNowAcademicYear(new Date()),
        nowAcademicSemester: getNowAcademicSemester(new Date()),
        talents: [],
        defaultKey: null,
        student: null,
        showGradeSemester: '11',
        isLearnedModal: false,
        isSuggestModal: false,
    }

    componentDidMount() {
        window.addEventListener('resize', this.resize.bind(this))
        this.resize()
        this.api_init_items()
    }

    // componentWillUnmount() {
    //     window.removeEventListener("resize", this.resize.bind(this))
    // }

    resize() {
        this.setState({ deviceWidth: window.innerWidth });
    }

    // 遠端數據處理 //////////////////////////////////////////////
    api_init_items = async () => {
        const { userCode, token } = this.props.user
        this.setState({ loading: true })
        const student = await req_single_cms_school_student(userCode, token)
        this.setState({ student })
        const { nowAcademicYear, nowAcademicSemester } = this.state
        const { enrollmnetYear } = student
        let grade = nowAcademicYear - enrollmnetYear
        let semester = 1
        if (nowAcademicSemester === 2) {
            grade = grade + 1
            semester = nowAcademicSemester - 1
        }
        else {
            if (grade === 0) {
                //一年級上學期
                grade = 1
                semester = 1
            }
            else {
                semester = 2
            }
        }
        const showGradeSemester = grade.toString() + semester.toString()
        this.setState({ showGradeSemester })

        const yearplan = await req_single_cms_learnmap_yearplan(student, token)
        //console.log(yearplan)
        if (yearplan) {
            const tab = await req_single_cms_learnmap_talent_tab(userCode, token)
            if (tab) {
                if (tab.total > 0) {
                    const talents = tab.data
                    const defaultKey = talents[0].nidTalent
                    this.setState({ talents, defaultKey })
                    this.tab_change(defaultKey)
                    //console.log('talents', talents)
                }
                this.setState({ loading: false })
            } else {
                this.setState({ loading: false })
            }
        } else {
            this.setState({ loading: false })
        }
    }

    // 數據配置處理 //////////////////////////////////////////////

    set_label_text = (key, value) => {
        let text = ''
        switch (key) {
            case 'ABILITY':
                switch (value) {
                    case 'COMMON':
                        text = '基本素養'
                        break
                    case 'PROFESSION':
                        text = '核心能力'
                        break
                    default:
                }
                break;
            default:

        }
        return text
    }

    set_label_color = (key, value) => {
        let color = 'black'
        switch (key) {
            case 'ABILITY':
                switch (value) {
                    case 'COMMON':
                        color = 'green'
                        break
                    case 'PROFESSION':
                        color = 'volcano'
                        break
                    default:
                }
                break;
            default:

        }
        return color
    }

    // 介面互動處理 //////////////////////////////////////////////

    tab_change = async (key) => {
        const { token } = this.props.user
        const { showGradeSemester, talents } = this.state
        const talent = talents.filter(function (e) {
            return e.nidTalent.toString() === key.toString()
        })
        const item = {
            gidLearnMapMeta: talent[0].gidLearnMapMeta,
            nidLearnMapMeta: talent[0].nidLearnMapMeta,
            student: talent[0].studentId,
            department: talent[0].departmentInsideCode,
            enrollmnetYear: talent[0].enrollmnetYear,
            gidTalent: talent[0].gidTalent,
            nidTalent: talent[0].nidTalent,
            gradeSemester: showGradeSemester
        }
        this.setState({ items: [] })
        this.setState({ tableloading: true })
        const result = await req_single_cms_learnmap_talent_suggest_course(item, token)

        if (result.total > 0) {
            const row = result.data
            const items = row.sort((a,b) => (a.abilityCategoryCode > b.abilityCategoryCode) ? 1 : -1)
           
            this.setState({ items })
           // console.log('items', items)
            this.setState({ tableloading: false })
        } else {
            this.setState({ tableloading: false })

        }
        //console.log('item', item)
        //console.log('talent', talent)
    }

    course_learned_btn = (item) => {
        this.setState({ item, isLearnedModal: true })
        // console.log(item)
    }

    course_suggest_btn = (item) => {
        this.setState({ item, isSuggestModal: true })
        // console.log(item)
    }

    /////////////////////////////////////////////////////////////    
    
    render() {
        const { loading, tableloading, items, item, talents, defaultKey, isLearnedModal, isSuggestModal } = this.state
        const tabPanes = talents.length > 0 ? talents.map((row, idx) => <TabPane tab={row.talentTwName} key={row.nidTalent}>
            <Alert key={row.nidTalent}
                description={row.talentDescription}
                type="success"
                showIcon
            />
        </TabPane>
        ) : ''
        const columns = [
            {
                title: '能力屬性',
                width: 10,
                responsive: ['md'],
                render: (item) => {
                    const { abilityCategoryCode } = item
                    return (
                        <div className='text-center'>
                            <Tag color={this.set_label_color('ABILITY', abilityCategoryCode)}><i className={abilityCategoryCode === 'PROFESSION' ? 'fa fa-podcast' : 'fas fa-street-view'}></i> {this.set_label_text('ABILITY', abilityCategoryCode)}</Tag>
                        </div>
                    )
                },
            },
            {
                title: '指標名稱',
                width: 60,
                render: (item) => {
                    const { abilityAcronym } = item
                    return (
                        <span style={{ fontSize: '1.4em' }}>{abilityAcronym}</span>
                    )
                },
            },
            {
                title: '已修課程',
                width: 20,
                render: (item) => {
                    const { talents } = this.state
                    const talent = talents.filter(function (e) {
                        return e.gidTalent === item.gidTalent
                    })
                    const obj = {
                        abilityName: item.abilityAcronym,
                        nidLearnMapMeta: talent[0].nidLearnMapMeta,
                        nidTalent: talent[0].nidTalent,
                        gidTalentAbility: item.gidTalentAbility,

                    }
                    return (
                        <div className='text-center'>
                            <button type="button" className="btn btn-primary btn-sm" onClick={() => this.course_learned_btn(obj)}><i className="fa fa-th-list"></i> 查閱</button>
                        </div>
                    )
                },
            },
            {
                title: '選課導航',
                width: 20,
                render: (item) => {
                    const { talents } = this.state
                    const talent = talents.filter(function (e) {
                        return e.gidTalent === item.gidTalent
                    })
                    const obj = {
                        abilityName: item.abilityAcronym,
                        nidLearnMapMeta: talent[0].nidLearnMapMeta,
                        nidTalent: talent[0].nidTalent,
                        gidTalentAbility: item.gidTalentAbility,

                    }
                    return (
                        <div className='text-center'>
                            <button type="button" className="btn btn-primary btn-sm" onClick={() => this.course_suggest_btn(obj)}><i className="fa fa-indent"></i> 查閱</button>
                        </div>
                    )
                },
            },
        ]
        const htmlItems = talents.length > 0 ? (<Card>
            <Tabs defaultActiveKey={defaultKey} onChange={this.tab_change}>
                {tabPanes}
            </Tabs>
            {tableloading ? (
                <div className='text-center'>
                    <p />
                    <button className="btn " type="button" disabled>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: '4px' }}></span>
                        Loading...
                    </button>
                </div>
            ) : (<>
                <Table
                    bordered
                    style={{ width: '99%' }}
                    scroll={{ y: 560 }}
                    rowKey='gidTalentAbility'
                    dataSource={items}
                    pagination={false}
                    columns={columns}
                />
            </>)}
        </Card>) : (<Alert
            message="無相關資訊(此功能僅適用日四技查詢)"
            type="warning"
            closable
        />)
        return (
            <> {loading ? (<div className='text-center'>
                <p />
                <button className="btn " type="button" disabled>
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: '4px' }}></span>
                    Loading...
                </button>
            </div>) : (<>
                {htmlItems}
                <Modal
                    destroyOnClose={true}
                    visible={isLearnedModal}
                    width={600}
                    onOk={() => {
                        this.setState({ isLearnedModal: false })
                    }}
                    onCancel={() => {
                        this.setState({ isLearnedModal: false })
                    }}
                    cancelButtonProps={{ style: { display: 'none' } }}
                >
                    <CoursemapStudentLearnedCourseModal course={item} />
                </Modal>
                <Modal
                    destroyOnClose={true}
                    visible={isSuggestModal}
                    width={800}
                    onOk={() => {
                        this.setState({ isSuggestModal: false })
                    }}
                    onCancel={() => {
                        this.setState({ isSuggestModal: false })
                    }}
                    cancelButtonProps={{ style: { display: 'none' } }}
                >
                    <CoursemapStudentSuggestCourseModal course={item} />
                </Modal>
            </>)}</>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(CoursemapStudentCourseSuggest)